import { render, staticRenderFns } from "./SearchPreferencesForm.vue?vue&type=template&id=e261b364"
import script from "./SearchPreferencesForm.vue?vue&type=script&lang=js"
export * from "./SearchPreferencesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports